import { showFailed } from "../../CommonFunction/SweetAlert";
import { QuerySelector3 } from "./QuerySelector";

export const fetchUserList = async (jwtToken, paginationData, searchQuery, bankID, branchID, role) => {
    try {
        const query = QuerySelector3(
            paginationData,
            searchQuery,
            bankID,
            branchID,
            role
          );
        const response = await fetch(
            `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/user/user-organizations-list?${query}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );
        const data = await response.json();
        console.log("first---", data);
        if (response.ok) {
            return data;
        } else {
            showFailed(`Failed.`, `${data.error[0]}`);
            return data;
        }
    } catch (error) {
        showFailed('Failed.', error);
    }
};
